import styled from '@emotion/styled';
import React from 'react';
import { Image, Pressable } from 'react-native';
import {
  green,
  white,
  bottomBarShadow,
  borderColor,
} from '@/shared/styles/colors';
import { ZIndex } from '@/shared/styles/constants';
import { VIDEO_CHAT_WEB_PANEL_WIDTH } from '@/shared/constants/videoSession';
import Channel from '@/components/messages/Channel/Channel';

interface VideoChatProps {
  channelUrl: string;
  isOpen: boolean;
  onClose: () => void;
}

const VideoChat = ({ channelUrl, isOpen, onClose }: VideoChatProps) => {
  if (!channelUrl || !isOpen) {
    return null;
  }

  return (
    <Container>
      <Header>
        <ChatIconWrapper>
          <Image
            source={require('@/assets/images/video/ChatVideoIcon.png')}
            alt="Chat"
            resizeMode="contain"
            style={{ width: 24, height: 24 }}
          />
        </ChatIconWrapper>
        <Pressable onPress={onClose}>
          <Image
            source={require('@/assets/images/CloseIcon.png')}
            alt="Close"
            resizeMode="contain"
            style={{ width: 24, height: 24 }}
          />
        </Pressable>
      </Header>
      <ChannelContainer>
        <Channel channelUrl={channelUrl} />
      </ChannelContainer>
    </Container>
  );
};

export default VideoChat;

const Container = styled.div({
  position: 'fixed',
  top: 0,
  right: 0,
  width: VIDEO_CHAT_WEB_PANEL_WIDTH,
  height: '100vh',
  backgroundColor: white,
  zIndex: ZIndex.TopLayer,
  display: 'flex',
  flexDirection: 'column',
  boxShadow: `-2px 0 8px ${bottomBarShadow}`,
});

const Header = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px',
  backgroundColor: green,
  borderBottom: `1px solid ${borderColor}`,
});

const ChatIconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  filter: 'brightness(0) invert(1)',
});

const ChannelContainer = styled.div({
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});
